import * as React from 'react'

const SvgElephantSad = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={163}
    height={120}
    viewBox="0 0 163 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#ElephantSad_svg__a)">
      <path
        d="M57.797 119.975a21.138 21.138 0 0 1-13.84-5.109c-9.04 5.142-21.494 4.583-21.494 4.583l-2.254-5.852s13.623.376 17.646-7.337C14.466 40.35 66.728 21.544 66.728 21.544s39.8 27.488 59.449 16.478c.1-.05.192-.117.292-.167v-.017L113.448 2.137a3.434 3.434 0 0 0-.234-.501h17.454c7.955 0 15.251 4.474 18.806 11.586 7.98 15.968 19.216 46.995 10.668 83.873h-10.375c1.469-52.129-20.576-50.968-20.576-50.968l26.477 73.848h-27.913L106.252 86.06l12.137 33.915H57.797Z"
        fill="#7130C9"
      />
      <path
        d="m86.995 120-7.721-21.72c0 11.995-9.591 21.72-21.428 21.72M106.719 43.773a46.37 46.37 0 0 0 3.974-.45c.501-.076 1.001-.168 1.502-.26a46.47 46.47 0 0 0 14.024-5.1c.1-.05.192-.117.292-.167a41.119 41.119 0 0 1-14.85 2.496 41.27 41.27 0 0 1-20.751-6.06 43.226 43.226 0 0 1-3.014-2.028 43.71 43.71 0 0 1-2.838-2.296 40.746 40.746 0 0 1-4.173-4.307 40.352 40.352 0 0 1-4.934-7.362c-2.186.5-9.173 3.314-9.173 3.314 4.65 13.814 20.584 22.746 37.754 22.337h.117c.693-.017 1.378-.05 2.07-.1v-.017Z"
        fill="#440A78"
      />
      <path
        d="M112.203 43.064a46.464 46.464 0 0 0 14.024-5.1c.1-.05.192-.117.292-.168-.1.059-.192.117-.292.167a46.551 46.551 0 0 1-14.024 5.1Z"
        fill="#440A78"
      />
      <path
        d="M90.918 34.224a41.27 41.27 0 0 0 20.751 6.06c4.925.092 9.95-.71 14.85-2.496L113.497 2.07a3.157 3.157 0 0 0-4.04-1.886L73.397 13.33l2.554 4.891c4.407 8.43 10.968 13.23 11.945 13.957a38.024 38.024 0 0 0 3.013 2.028l.009.017Z"
        fill="#9865FC"
      />
      <path d="M113.264 1.569a3.433 3.433 0 0 0 0 0Z" fill="#9865FC" />
      <path
        d="M131.619 22.045a4.036 4.036 0 0 0 5.359 1.978 4.035 4.035 0 0 0 1.978-5.358 13.627 13.627 0 0 1-7.345 3.38h.008Z"
        fill="#fff"
      />
      <path
        d="M127.829 117.446c-.042-5.877 8.498-5.785 8.765 0h-1.503c.075-6.595 9.625-6.494 9.934 0h-2.588c-.033-1.369.568-2.746 1.561-3.673 2.996-2.93 8.564-.584 7.738 3.673-.034.133-.217.125-.251 0-.501-2.646-3.948-3.973-5.718-1.903-.492.551-.734 1.26-.751 1.986-.1 1.678-2.596 1.595-2.579-.083 0-3.99-5.701-3.807-5.843.075-.059.985-1.528.918-1.503-.075.192-2.963-3.614-4.616-5.759-2.571a3.779 3.779 0 0 0-1.244 2.571c0 .15-.25.15-.25 0h-.009ZM89.115 117.446c-.042-5.877 8.498-5.785 8.765 0h-1.503c.075-6.595 9.625-6.494 9.933 0h-2.587c-.034-1.369.567-2.746 1.561-3.673 2.996-2.93 8.564-.584 7.738 3.673-.034.133-.217.125-.251 0-.501-2.646-3.948-3.973-5.718-1.903-.492.551-.734 1.26-.751 1.986-.1 1.678-2.596 1.595-2.579-.083 0-3.99-5.701-3.807-5.843.075-.059.985-1.528.918-1.503-.075.192-2.963-3.614-4.616-5.76-2.571a3.782 3.782 0 0 0-1.243 2.571c0 .15-.25.15-.25 0h-.009ZM22.512 119.441H.576a.575.575 0 0 1-.384-1.002c3.814-3.356 16.444-13.556 20.066-4.85l2.254 5.852ZM61.945 65.125l20.902.576c1.052.034 5.643.134 6.586.2 5.167.26 10.125 3.164 12.905 7.471 1.794 2.613 2.796 6.97 3.865 9.95 2.095 6.37 7.629 23.231 9.782 29.792-2.52-6.553-8.839-22.955-11.268-29.266l-1.878-4.875c-.568-1.527-1.227-3.121-2.212-4.432-2.838-4.015-7.697-6.277-12.563-5.96-3.422.092-22.304.61-26.127.718-2.805 0-2.846-4.165 0-4.174h.008Z"
        fill="#440A78"
      />
    </g>
    <defs>
      <clipPath id="ElephantSad_svg__a">
        <path fill="#fff" d="M0 0h163v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgElephantSad
